export interface ContractSpec {
  symbol: string;
  name: string;
  exchange: string;
  tickSize: number;
  tickValue: number;
  pointValue: number;
  dayMargin: number;
  overnightMargin: number;
}

export const CONTRACTS: Record<string, ContractSpec> = {
  ES: {
    symbol: 'ES',
    name: 'E-mini S&P 500',
    exchange: 'CME',
    tickSize: 0.25,
    tickValue: 12.50,
    pointValue: 50.00,
    dayMargin: 500,
    overnightMargin: 14000,
  },
  NQ: {
    symbol: 'NQ',
    name: 'E-mini NASDAQ-100',
    exchange: 'CME',
    tickSize: 0.25,
    tickValue: 5.00,
    pointValue: 20.00,
    dayMargin: 500,
    overnightMargin: 20000,
  },
  MES: {
    symbol: 'MES',
    name: 'Micro E-mini S&P',
    exchange: 'CME',
    tickSize: 0.25,
    tickValue: 1.25,
    pointValue: 5.00,
    dayMargin: 50,
    overnightMargin: 1400,
  },
  MNQ: {
    symbol: 'MNQ',
    name: 'Micro E-mini NASDAQ',
    exchange: 'CME',
    tickSize: 0.25,
    tickValue: 0.50,
    pointValue: 2.00,
    dayMargin: 50,
    overnightMargin: 2000,
  },
  CL: {
    symbol: 'CL',
    name: 'Crude Oil',
    exchange: 'NYMEX',
    tickSize: 0.01,
    tickValue: 10.00,
    pointValue: 1000.00,
    dayMargin: 500,
    overnightMargin: 7500,
  },
  GC: {
    symbol: 'GC',
    name: 'Gold',
    exchange: 'COMEX',
    tickSize: 0.10,
    tickValue: 10.00,
    pointValue: 100.00,
    dayMargin: 500,
    overnightMargin: 11000,
  },
};

export const DEFAULT_CONTRACT = 'ES';
